import { DataSource } from 'hooks/useHttpClient';
import { FactAudit } from './Common';

// TODO FOR MICROSRVICES -- Add more logic to add title, reponses, private comments, etc.
export type Comment = {
    id: number;
    comment: string;
    private: boolean;
    createdAudit: FactAudit;
    responses: Comment[];
};

export function CommentListResolver(dataSource: DataSource, apiResponse: any, resolveResponses?: boolean): Comment[] {
    try {
        switch (dataSource) {
            case 'hyrerocket':
                return apiResponse.map((co: any) => ({
                    id: co.id,
                    comment: co.comment || co.text,
                    private: co.private || false,
                    createdAudit: {
                        userId: co.user?.id || co.created_by?.id || 0,
                        userFullName: co.user?.name || co.created_by?.name || '',
                        avatar: co.user?.avatar || co.created_by?.avatar || '',
                        dateStr: co.created_at || co.updated_at
                    },
                    responses: resolveResponses ? CommentListResolver(dataSource, co.responses, false) : []
                }));

            default:
                return [];
        }
    } catch (error) {
        console.error(error);
        return [];
    }
}
